let navItems = [...document.querySelectorAll('.header__inline-menu li a')];

navItems.forEach((item) => {
  if(window.location.href === item.href) {
    item.querySelector('span').classList.add('header__active-menu-item');
  }
});

//Recipe Filter
const recipeFilter = document.querySelector('.recipe-mobile-icon');

const toggleFilter = () => {
  recipeFilter.classList.toggle('active');
}

if(recipeFilter){
  recipeFilter.addEventListener('click', toggleFilter);
}

